// JS for block-specific behavior only
console.log('res split rows block loaded');